import React,{useEffect,useRef} from 'react'
import '../gcliente.css';
import {useHistory} from 'react-router-dom';
import axios from 'axios';
import {BrowserRouter as Router,Switch,Route} from 'react-router-dom';
import Pesquisarcliente from './pesquisarcliente';
import GestClienteopc from './gestClienteopc';
import ListarCliente from './ListarCliente';
import Reclamacoes from './Reclamacoes';
import Dividas from './Dividas';
import ClienteRegistro from './ClienteRegistro';
import Refund from './Refund';
import Gateway from './Gateway';
function GestCliente() {
    const ref=useRef([]);
    
    useEffect(()=>{localStorage.setItem('cliheig',ref.current.offsetHeight)},[])
    
    
    return (
        
        <Router>
        
        <div className="Gcliente" ref={ref}>
                <GestClienteopc/ >
                <div>
                    <Switch>
                        <Route path="/home/gest-cliente/pesquisar-cliente" exact component={Pesquisarcliente}/>
                        <Route path="/home/gest-cliente/listar-cliente" exact component={ListarCliente}/>
                        <Route path="/home/gest-cliente/reclamacoes" exact component={Reclamacoes}/>
                        <Route path="/home/gest-cliente/refund" exact component={Refund}/>
        
                        <Route path="/home/registar-cliente" exact component={ClienteRegistro}/>
                        <Route path="/home/gest-cliente/Dividas" exact component={Dividas}/> 
                        <Route path="/home/gest-cliente/gateway" exact component={Gateway}/> 
                            
                    </Switch>
                </div>
            
        </div>
        
        </Router>
         )
}

export default GestCliente
